import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';

const GPSTrackingSoftware = () => {
  return (
    <Layout>
      <section id="greenorange-dest">
        <section className="banner">
          <div className="container">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12">
                <h1 className="mar0">GPS as Software</h1>
                <p className="colorWht">Communications and Information technology help to interconnect remote machines and objects, systems and people.</p>
              </div>
            </div>
          </div>
        </section>
        <section className="content-dest">
          <div className="col-lg-12 content-dest-bg">
            <div className="col-lg-5 col-md-5 col-sm-6 padTB58 text-right">
              <img src="/images/gps_tracker.png" alt="gps_tracker" className="content-img" />
            </div>
            <div className="col-lg-3 col-md-3 col-sm-6 padTB58 padLR15">
              <p>
                Not long ago it seemed that everything is already discovered in GSM network, but HSCSD, GPRS, EDGE bearers created new possibilities for remote control - M2M technology came up, which created new solutions.
              </p>
              <p>
                M2M means machine-to-machine, man-to-machine and machine-to-mobile. M2M extends understanding of communication, this is a way to communicate not only for people, but for machines as well. In the mobile world M2M together with communications and information technology help to interconnect remote machines and objects, systems and people.
              </p>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-12 bgwhite">
              <div className="dest-rightside gps-soft">
                <div>You may also be interested in <span> our other products</span></div>
                <ul className="pad0">
                  <li><Link to="/transport-management-system" title="Transport Management System">Transport Management System</Link></li>
                  <li><Link to="/payroll" title="Payroll Management System">Payroll Management System</Link></li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        <div className="clearfix"></div>
        <section className="content-dest1">
          <div className="container">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12">
                <h2>Why M2M Solutions are needed?</h2>
                <p>
                  It is a proven standard, designed to make customer's requirements come true, by using complex data transfer services. Continuity of GSM networks, easy installation and mobility help to reduce cost and time.
                </p>
                <p>Controll your Fleet from any PC, iOS or Android running device</p>
                <p>When do You need it?</p>
                <ul>
                  <li>When You want to use GreenOrange GTrackwithout any installation</li>
                  <li>When You want to see ALL applications possibilities (track, reports, driver information etc.) whether You use any PC or iOS/Android running device</li>
                </ul>
                <p>Where is it possible to connect from?</p>
                <ul>
                  <li>Personal Computer</li>
                  <li>Android or iOS operating systems</li>
                </ul>
                <p>With GreenOrangeGTrack you can:</p>
                <ul>
                  <li>Easily monitor GPS information about objects (G, GF and GT series) in one window</li>
                  <li>See last position on the map when your GPS device was active with all extra information</li>
                  <li>Track vehicle trip on particular time with graphical reports</li>
                </ul>
                <h3>Additional Features:</h3>
                <ul>
                  <li>GPS tracker remote configuration</li>
                  <li>GeoFence Zones</li>
                  <li>Event configuration</li>
                  <li>Routing</li>
                  <li>SMS functionality</li>
                  <li>Local grouping</li>
                </ul>
                <h3>Reports</h3>
                <ul>
                  <li>Distance By Work Time Daily</li>
                  <li>Driven Distance</li>
                  <li>Driven Distance Daily</li>
                  <li>Fuel Tank</li>
                  <li>Fuel Tank – Car Report</li>
                  <li>Geofencing</li>
                  <li>Moto Hours Daily</li>
                  <li>Trip Stops</li>
                  <li>Trip Stops Daily</li>
                  <li>Trip Stops Daily (Without GeoInfo)</li>
                  <li>Work Time</li>
                  <li>Work Time Detailed</li>
                </ul>
                <h3>Fuel consumption solutions with GTrack</h3>
                <p>With G53 GTrack application You have following options to monitor fuel consumption:</p>
                <ul>
                  <li>Show fuel level at the moment</li>
                  <li>Show fuel usage per period of time</li>
                  <li>Show average fuel usage</li>
                  <li>Show fuel temperature information</li>
                </ul>
                <p>Available fuel sources:</p>
                <ul>
                  <li>LLS fuel sensor</li>
                  <li>CAN-bus</li>
                  <li>Impulse fuel counter</li>
                  <li>Analog input</li>
                </ul>
              </div>
            </div>
          </div>
        </section>
      </section>
    </Layout>
  );
};

export default GPSTrackingSoftware;

